module.exports = function(){ /* empty */ };


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/modules/$.unscope.js
 ** module id = 246
 ** module chunks = 46 47
 **/